import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { IconModule } from '@pc-ui/icon';
import { SpinnerModule } from '@pc-ui/spinner';
import { ButtonComponent } from './button.component';

@NgModule({
  declarations: [ButtonComponent],
  imports: [CommonModule, IconModule, SpinnerModule],
  exports: [ButtonComponent],
})
export class ButtonModule {}
